'use strict';
class AppData {
  isInit() {
    return this.if != null || this.if != undefined;
  }

  Init(iapp) {
    this.if = iapp;
  }

  Uninit() {
    this.if = null;
  }

  GetApp() {
    return this.if;
  }

  getRequest() {
    return this.if.iRequest;
  }

  getHost() {
    return this.if.iHost;
  }

  getNotify() {
    return this.if.iNotify;
  }

  getCookie() {
    return this.if.iCookie;
  }

  getAuth() {
    return this.if.iAuth;
  }

  getStorage() {
    return this.if.iStorage;
  }

  getAppInfo() {
    return this.if.iAppInfo;
  }

  isStagingMode() {
    return this.if.iAppInfo && this.if.iAppInfo.isStagingMode();
  }

  isAndroid() {
    return this.if.iAppInfo && this.if.iAppInfo.getAppPlat() == 'android' ? true : false;
  }

  isIOS() {
    return this.if.iAppInfo && this.if.iAppInfo.getAppPlat() == 'ios' ? true : false;
  }

  isInPc() {
    return this.if.iAppInfo && this.if.iAppInfo.getBslPlat() == 'PC' ? true : false;
  }

  isInM() {
    return this.if.iAppInfo && this.if.iAppInfo.getBslPlat() == 'M' ? true : false;
  }

  isInRN() {
    return this.if.iAppInfo && this.if.iAppInfo.getBslPlat() == 'RN' ? true : false;
  }

  //是否在微信小程序中使用
  isInWeixinLite() {
    let result = false;
    if (
      this.if.iAppInfo &&
      (this.if.iAppInfo.getBslPlat().toLowerCase() == 'weixinlite' ||
        this.if.iAppInfo.getBslPlat().toLowerCase() == 'wxlite')
    ) {
      result = true;
    }
    return result;
  }

  //是否在小程序中使用 （包括头条，抖音，微信）
  isInLite() {
    let result = false;
    if (
      this.if.iAppInfo &&
      (this.if.iAppInfo.getBslPlat().toLowerCase() == 'weixinlite' ||
        this.if.iAppInfo.getBslPlat().toLowerCase() == 'wxlite' ||
        this.if.iAppInfo.getBslPlat().toLowerCase() == 'ttlite' ||
        this.if.iAppInfo.getBslPlat().toLowerCase() == 'dylite')
    ) {
      result = true;
    }
    return result;
  }

  //是否MIUI直达服务
  isInMiuiLite() {
    return this.if.iAppInfo && this.if.iAppInfo.getBslPlat() == 'MIUILite' ? true : false;
  }

  isInYoupinApp() {
    let result = false;
    if (this.if.iAppInfo && this.isInRN() && this.if.iAppInfo.getAppName().toLowerCase() == 'youpin') {
      result = true;
    }
    return result;
  }

  // isInMijiaApp() {
  //   let result =  false;
  //   if(this.if.iAppInfo && this.isInRN() && (this.if.iAppInfo.getAppName().toLowerCase() == 'mihome' || this.if.iAppInfo.getAppName().toLowerCase() == 'mijia' || this.if.iAppInfo.getAppName().toLowerCase() == 'smarthome')) {
  //     result = true;
  //   }
  //   return result;
  // }
  isInMijiaApp() {
    let result = false;
    if (
      this.if.iAppInfo &&
      this.isInRN() &&
      (this.if.iAppInfo.getAppName().toLowerCase() == 'mihome' ||
        this.if.iAppInfo.getAppName().toLowerCase() == 'mijia' ||
        this.if.iAppInfo.getAppName().toLowerCase() == 'smarthome')
    ) {
      result = true;
    }
    return result;
  }

  isInTuishouApp() {
    let result = false;
    if (
      this.if.iAppInfo &&
      (this.if.iAppInfo.getAppName().toLowerCase() == 'yptuishou' ||
        this.if.iAppInfo.getAppName().toLowerCase() == 'tuishou')
    ) {
      result = true;
    }
    return result;
  }

  getChannel() {
    return this.if.iAppInfo && this.if.iAppInfo.getChannel();
  }

  getFingerprint() {
    if (!this.if.iAppInfo) return '';
    return `${this.if.iAppInfo.getBslPlat()}_${this.if.iAppInfo.getAppName()}`;
  }

  getAppName() {
    return this.if.iAppInfo && this.if.iAppInfo.getAppName();
  }

  isLogined() {
    return this.if.iAuth && this.if.iAuth.isLogined();
  }

  getBslPlatForPay() {
    let appPlat = this.if.iAppInfo && this.if.iAppInfo.getAppPlat();
    let bslPlat = (this.if.iAppInfo && this.if.iAppInfo.getBslPlat()) || '';
    if (bslPlat && (bslPlat === 'RN' || bslPlat === 'WEEX')) {
      return appPlat.toLowerCase();
    }
    return bslPlat.toLowerCase();
  }

  /**
   * 是否为移动端
   * @returns {boolean}
   */
  get isMobile() {
    return this.isInRN() || this.isIOS() || this.isAndroid() || this.isInM() || this.isInLite() || this.isInMiui();
  }
}

let _appData = null;

function BSLCreateAppData(autoCreate) {
  if (!_appData && autoCreate) {
    _appData = new AppData();
  }

  return _appData;
}

class BSLAppHost {
  constructor(host, devHost) {
    this.host = host ? host : 'https://shopapi.io.mi.com';
    this.devHost = devHost ? devHost : 'https://st.shopapi.io.mi.com';
    this.tradeHost = 'https://trade.m.xiaomiyoupin.com';
    this.tradeDevHost = 'https://trade.m.st.xiaomiyoupin.com';
  }
  getHost(isDev) {
    return isDev ? this.devHost : this.host;
  }
  getTradeHost(isDev) {
    return isDev ? this.tradeDevHost : this.tradeHost;
  }
}

class BSLAppInterface {
  constructor() {
    this.iRequest = null;
    this.iNotify = null;
    this.iCookie = null;
    this.iStorage = null;
    this.iCache = null;
    this.iAuth = null;
    this.iHost = new BSLAppHost();
    this.iAppInfo = null;
  }

  getRequest() {
    return this.iRequest;
  }

  setRequest(request) {
    this.iRequest = request;
  }

  getNotify() {
    return this.iNotify;
  }

  setNotify(notify) {
    this.iNotify = notify;
  }

  getCookie() {
    return this.iCookie;
  }

  setCookie(cookie) {
    this.iCookie = cookie;
  }

  getAuth() {
    return this.iAuth;
  }

  setAuth(auth) {
    this.iAuth = auth;
  }

  getStorage() {
    return this.iStorage;
  }

  setStorage(storage) {
    this.iStorage = storage;
  }

  setCache(cache) {
    this.iCache = cache;
  }

  getCache() {
    return this.iCache;
  }

  setHost(host) {
    this.iHost = host;
  }

  getHost() {
    return this.iHost;
  }

  setAppInfo(appInfo) {
    this.iAppInfo = appInfo;
  }

  getAppInfo() {
    return this.iAppInfo;
  }
}
let appData = null;

function SetCore(iapp) {
  if (!iapp) {
    throw 'Need app frame interface';
  }
  appData = BSLCreateAppData(true);
  if (!appData.isInit()) {
    appData.Init(iapp);
  }
  return appData;
}

const BSLInit = (iapp) => {
  return SetCore(iapp);
};
// function GetCore() {
//   return appData.GetApp();
// }
function GetAppData() {
  return appData;
}

export { BSLInit, GetAppData, BSLAppInterface };
